var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("EBITDA por año fiscal")]),_c('ebit',{attrs:{"type":"EBITDA"}}),_c('br'),_c('h2',[_vm._v("EBIT por año fiscal (hasta FY22)")]),_c('ebit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }